import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Subscribe from './Subscribe';

const Blogpost1 = () => {
    useEffect(() =>{
        document.title = "Why and When You Should Invest in Real Estate in Nigeria | Earth VII"
    },[])

    const [RotateDg, setRotateDg] = useState()  

    const rotateDgCSS = {
        transform: "rotate(-25deg)",
        transition: "transform 0.2s ease 0s"
      }

      const removerotateDgCSS = {
        transform: "rotate(0deg)",
        transition: "transform 0.2s ease 0s"
      }

      const rotatedg = () =>{
        setRotateDg(rotateDgCSS) 
    }
    const stoprotatedg = () =>{
        setRotateDg(removerotateDgCSS) 
    }



    return (
      
      <div>
<div className="homepageslider" id="homepageslider">
<Header/>

<div  class="apartmentsfirstbox">
<div class="container">

<h3 className="blogherotitle">Why and When You Should Invest in Real Estate in Nigeria
   
   </h3>

   
<div class="row blogotherdets">

{/* <p className="blogdetails"> <img src="images/icons/calendar.png"/> 24 Jan, 2021</p>
    <p className="blogdetails"> <img src="images/icons/clock2.png"/> 4 mins, 23 secs read</p> */}

{/* 
    <div class="col-md-4">
    <p> <img src="images/icons/calendar.png"/> 24 Jan, 2021 <img style={{marginLeft:"10px"}} src="images/icons/clock2.png"/> 4 mins, 23 secs read</p>
        </div> */}

    </div>


   <div class="row">
<div class="col-md-12">
<img className="img-fluid" src="images/blog/blogpost1.png"/>

</div>


</div>






<div class="row blogbodycontent">

<div class="col-md-12">
<p className="blogcontent">If you are looking for a safe investment option, then real estate should be top on your search list. Real Estate investments offer what is arguably the most robust investment choice.</p>
<p className="blogcontent">In Nigeria particularly, many people are awakening to the world of benefits available in real estate. You will meet some of them while reading this article.</p>
<p className="blogcontent">Many people live in regret today over the fact that they did not maximize investment opportunities in real estate. Some simply made light of the relevance and settled for an insignificant share of available real estate. &nbsp;</p>
<p className="blogcontent">If you&rsquo;re reading this, then you are likely interested in real estate investment. The best time to secure your future by investing in real estate is now.</p>

<br/>
<br/>
<h4 className="arialfont">5 Things You Should Know Before Investing in Real Estate</h4>

<p className="blogcontent">There are some important points to note about real estate. We have compiled five below:</p>
<ul className="blogcontent" >
    <li><strong>Location of real estate is sacrosanct:</strong> Before buying any property, it is advisable to consider the location first. Some properties thrown afar off from civilization might take longer (if ever) to yield returns for the buyer compared to those strategically situated.</li>
    <br/>
    <li><strong>Purpose of investing in Real Estate or Property:</strong> There are different property types that one can invest in. the point is to clearly ascertain the use of the property type you wish to invest in so as to maximize profit and utility after purchase.</li>
    <br/>
    <li><strong>Cost Implication:</strong> Having a foreknowledge of how much your desired real estate investment choice will cost saves you time and resources of moving from one agent to another.</li>
    <br/>
    <li><strong>Find the right investment partner:</strong> We can think of only one name when it comes to safe and reliable real estate investment &ndash; REIF. Ensure to identify a reputable expert or organization to guide you in making real estate investment decision.</li>
    <br/>
    <li><strong>Tread with caution:</strong> The real estate sector of the Nigerian economy is almost saturated with self-acclaimed realtors and agents. &nbsp; &lsquo;Shine your eyes&rsquo; would be the mantra for the game but you could save yourself the hassle by going to Government or industry-approved Agencies like Rich Oak that are duly registered and recognized with over five years track record of service delivery.</li>
</ul>
<br/>
<br/>
<h4 >Benefits of Investing in Real Estate</h4>
<p className="blogcontent">Real estate investment is quite popular among many Nigerians for a number of reasons:</p>
<ol className="blogcontent">
    <li>High ROI: Real Estate investment pays one of the highest returns over a stipulated period to investors.</li>
    <br/>
    <li>Appreciates in Value: Whether you are doing a one-off purchase of real estate or investing in it to wait over a long period before use, they have tendency to only increase in market value.</li>
    <br/>
    <li>Resale Value: If you are in dire need of cash and wish to liquidate your real estate investment, there is a huge guarantee that you would always get a ready market for it.</li>
    <br/>
    <li>Flexibility of purpose: Whether you intend to build on a land, rent out a house or convert it into a commercial building, real estate caters for a variety of needs. &nbsp;</li>
    <br/>
    <li>You gain total control: Once payment is concluded and relevant documents are handed to the investor. You hold total control of the property in question unlike other types of investments where one&rsquo;s money continues to be at the mercy of the investment platform.</li>
</ol>
<br/>
<br/>
<h4 >Conclusion</h4>
<p className="blogcontent">You must have realized that real estate investment is a valid choice of investment if you want to make mouthwatering returns. The relatively safe nature of it proves to be one of the greatest motivations for all those venturing into the space.</p>
<p className="blogcontent">If Real Estate is not your area of interest but will rather enjoy good returns from an equally safe outlet, you should absolutely give Rich-Oak&apos;s Real Estate Investment Fund (REIF) a try.</p>
<p className="blogcontent">With a limited number of 200 available investment units and counting down, you can Invest from N500,000 for 1 unit and earn 24% of your Investment in 12 Months. You can Invest in as many Investment units as available under our REIF.</p>
<p className="blogcontent">It&apos;s secure, no stories after maturation of your investment and you get to monitor your funds being used for the right purpose.</p>
  
    </div>


</div>


    </div>

    </div>









    </div>

    <Subscribe/>




    <Footer/>
    </div>


    )
    
    
}


export {Blogpost1 as default}